var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"header"}},[_c('h2',[_vm._v(_vm._s(_vm.Personality))])]),_c('about-comp',{attrs:{"about":_vm.about}}),_c('history-comp',{attrs:{"history":_vm.history}}),_c('factor-comp',{attrs:{"factors":_vm.factors}}),_c('type-comp',{attrs:{"types":_vm.types_data}}),_c('detail-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }